export default "__VITE_ASSET__D1up9gpA__"